// stores/assetStore.ts
import { makeAutoObservable, observable } from "mobx";
import api, {
  PostAssetUploadParameters,
  GetAssetRes,
  PostAssetUploadRes,
} from "../api";
import { createRequestStatus, handleRequest } from "../toll/toolRequestStatus";

class AssetStore {
  uploadAssetStatus = createRequestStatus();
  assetStatusMap = observable.map<string, ReturnType<typeof createRequestStatus>>();
  uploadAsset = observable.map<string, GetAssetRes>();
  assetMap = observable.map<string, GetAssetRes>();

  constructor () {
    makeAutoObservable(this);
  }



  postUploadAsset = async (params: PostAssetUploadParameters) => {
    await handleRequest<PostAssetUploadRes>(
      this.uploadAssetStatus,
      () => api.PostAssetUpload(params),
      (res) => {
        this.uploadAsset.set(res.id, res)
      },
      "资产上传失败"
    );
  };

  getAsset = async (id: string) => {

    if (!this.assetStatusMap.has(id)) {
      this.assetStatusMap.set(id, createRequestStatus());
    }
    const statusObj = this.assetStatusMap.get(id)!;

    await handleRequest<GetAssetRes>(
      statusObj,
      () => api.GetAsset(id),
      (res) => {
        this.assetMap.set(res.id, res)
      },
      "获取资产失败"
    );
  };
}

const assetStore = new AssetStore();
export default assetStore;
